// extracted by mini-css-extract-plugin
export var footer = "_q6-0";
export var inherit = "_q6-1";
export var input = "_q6-2";
export var modalContent = "_q6-3";
export var quillEditor = "_q6-4";
export var subtitle = "_q6-5";